import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NcsMeetingList from "./ncsMeetingList";
import { getNcsMeetings } from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    ncsMeetings: state.baMeetingReducer.ncsMeetings
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getNcsMeetings,
        },
        dispatch
);
export default connect(mapStateToProps, mapDispatchToProps)(NcsMeetingList);